export default "__VITE_PUBLIC_ASSET__1c6c70d3__"